<template>
  <div v-loading.fullscreen="loading">
    <div v-if="!loading">
      <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'refereeList' }"> {{$t('entities.referee.plural')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model.name }}</el-breadcrumb-item>
      </el-breadcrumb>

      <h2 class="page-title">
         {{$t('entities.referee.singular')}}
      </h2>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidth"
        :class="{ show: true, 'show-mobile': isMobile }"
        v-on:submit.native.prevent
      >
        <el-form-item label="Id">
          {{ model.id }}
        </el-form-item>

        <el-form-item label="Name">
          {{ model.name }}
        </el-form-item>

        <el-form-item label="LastName">
          {{ model.lastName }}
        </el-form-item>

        <el-form-item label="Email">
          {{ model.email }}
        </el-form-item>

        <el-form-item label="Phone">
          {{ model.phone }}
        </el-form-item>

        <el-form-item label="Created at">
          {{ model.created | formatDatetime }}
        </el-form-item>

        <el-form-item label="Updated at">
          {{ model.modified | formatDatetime }}
        </el-form-item>

        <div class="button-group mt-3">
          <el-button
            v-if="hasRoleToUpdate"
            icon="el-icon-fa-pencil-square-o"
            @click="edit()"
            type="primary"
          >
            {{$t('table.edit')}}
          </el-button>
          <el-button
            v-if="hasRoleToReadLogs"
            icon="el-icon-fa-history"
            @click="history()"
            type="infor"
          >
            {{$t('table.history')}}
          </el-button>
          <el-button
            v-if="hasRoleToDelete"
            icon="el-icon-fa-trash"
            @click="destroy()"
            type="danger"
          >
            {{$t('table.delete')}}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-referee-show',

  props: {
    id: String,
  },

  created() {
    this.$store
      .dispatch('entities/referee/detail', this.id)
      .catch(() =>
        this.$router.push({ name: 'refereeList' }),
      );
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/referee/clear');
    next();
  },

  computed: {
    ...mapGetters({
      model: 'entities/referee/model',
      loading: 'entities/referee/loading',
      hasRoleToDelete: "entities/referee/hasRoleToDelete",
      hasRoleToUpdate: "entities/referee/hasRoleToUpdate",
      hasRoleToRead: "entities/referee/hasRoleToRead",
      hasRoleToReadLogs: "entities/referee/hasRoleToReadLogs",
      hasRoleToCreate: "entities/referee/hasRoleToCreate",
      isMobile: "shared/isMobile",
      labelPosition: "shared/labelPosition",
      labelWidth: "shared/labelWidth"
    }),
  },

  methods: {
    edit() {
      this.$router.push({
        name: 'refereeEdit',
        params: { id: this.id, previous: 'show' },
      });
    },

    destroy() {
      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      })
        .then(() =>
          this.$store.dispatch(
            'entities/referee/destroy',
            this.id,
          ),
        )
        .then(() =>
          this.$router.push({ name: 'refereeList' }),
        )
        .catch(() => {});
    },

    history() {
      this.$router.push({
        name: 'refereeHistorySingle',
        params: { id: this.id },
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/referee/referee-show.vue?35923986